import {queryPayableStatistics} from '@api/incubator/payable';

// 孵化器账单统计
const PAYABLE_STATIS = 'PAYABLE_STATIS';

export function getPayableStatistics(params) {
  return dispatch => {
    return queryPayableStatistics({ ...params }).then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: PAYABLE_STATIS,
          data: res.data,
        });
      }
    });
  };
}

export function payableStatis(state = {}, action) {
  switch (action.type) {
    case PAYABLE_STATIS:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/payable_statis.js